import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,{style:(['height:' + _vm.height + 'px']),attrs:{"align":"center","justify":"center"}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"6"}},[_c(VProgressLinear,{attrs:{"color":"primary","height":"7","indeterminate":"","rounded":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }